export function toggleSelectionValue(
  values: string[],
  nextValue: string,
  normalize?: (value: string) => string,
  maxValues?: number,
): string[] {
  const normalized = normalize
    ? normalize(nextValue.trim())
    : nextValue.trim();
  if (!normalized) return values;
  if (values.includes(normalized)) {
    return values.filter((item) => item !== normalized);
  }
  if (maxValues !== undefined && values.length >= maxValues) {
    return values;
  }
  return [...values, normalized];
}

export function appendSelectionValues(
  values: string[],
  nextValues: string[],
  normalize?: (value: string) => string,
  maxValues?: number,
): string[] {
  const merged = [...values];
  nextValues.forEach((item) => {
    if (maxValues !== undefined && merged.length >= maxValues) {
      return;
    }
    const normalized = normalize ? normalize(item.trim()) : item.trim();
    if (normalized && !merged.includes(normalized)) {
      merged.push(normalized);
    }
  });
  return merged;
}
